var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.cardType !== 'unknown' && _setup.svgSrc)?_c('span',[_c('img',{style:({ width: _vm.width + 'px' }),attrs:{"src":_setup.svgSrc,"alt":"card"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }